export class CategoryChannelModel {
    id?:number
    idCategory?:number
    idChannel:number
    idExternalChannel:string
    isActive:boolean = false
    allowExport:boolean = false

    constructor(c?: Partial<CategoryChannelModel>) {
        Object.assign(this, c)
    }
}
